import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MapHelperService } from "../../map-helper.service";
import { TurfHelperService } from 'src/services/turf-helper.service';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { FeatureCollection, Point } from '@turf/helpers';
import { EnumFeaturesActionsDestinations } from 'src/app/features/shared/helpers/enums/EnumFeaturesActionsDestinations';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { environment } from "src/environments/environment";
import { customDrawStyles } from '../utils/mapbox-draw-styles';

@Injectable({
  providedIn: "root",
})
export class PolygonDrawToolService {
  // Almacena los puntos del polígono del add polygon
  polygonPoints: number[][] = []; 

  //guarda el estado original del polgono dibujado
  public originalGeofencePolygonDrawData: any = null;
  isPolygonUpdateConfirmed: boolean = false;
  
  public originalGeofenceBufferDrawData: any = null;
  isBufferUpdateConfirmed: boolean = false;

  //guarda el centroide de un polygono redibujado, para los biffer de geocercas
  public polygonCentroid: Subject<number[]> = new BehaviorSubject<number[]>([]);



  constructor(
    private mapHelperService: MapHelperService,
    private turfHelperService: TurfHelperService,
    private swalNotificationService: SwalNotificationService,
    ) {
  }

  setPolygonCentroid(coordinates: number[]){
    this.polygonCentroid.next(coordinates);
  }

  getPolygonCentroid(): any {
    return this.polygonCentroid.asObservable();
  }

  //#region dibujador de geocercas
  // ------------- dibujador de poligono --------------
  drawGeofencePolygon = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
      polygon: false,
      trash: false,
      combine_features: false,
      uncombine_features: false,
    },
    styles: customDrawStyles,
  });

  updatePolygonArea = (e) => {
    const data = this.drawGeofencePolygon.getAll();
    if (data.features.length > 0) {
      var polygon = data.features[0] as any;
      const coordinates = polygon.geometry.coordinates[0];
      // mete las coordenadas en el arreglo
      this.polygonPoints = coordinates;
  
      var points = this.mapHelperService._map.getSource("pointsSource")._data;
      if(!environment.production) console.log("puntos", points);

      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, polygon);
      var features = turfFeaturesInsideArea.features;
      if(!environment.production) console.log("features", turfFeaturesInsideArea, features);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
      this.mapHelperService.featuresInsideArea.next(featuresResult);
  
      // this.panelAddGeofencesService.setIntersectedFeatures(features);
    } else {
      this.polygonPoints = [];
    }
  }

  updatePolygonAreaWithConfirmation = async (e) => {
    if (!this.isPolygonUpdateConfirmed){
      const resp = await this.swalNotificationService.confirmMessage("¿Deseas modificar el área de la geocerca?", 'Se actualizarán los puntos que se encuentran dentro de la geocerca.');
      if (!resp.isConfirmed){
        this.drawGeofencePolygon.set(this.originalGeofencePolygonDrawData);
        return;
      }
      this.isPolygonUpdateConfirmed = true;
    }

    const data = this.drawGeofencePolygon.getAll();
    if (data.features.length > 0) {
      var polygon = data.features[0] as any;
      const coordinates = polygon.geometry.coordinates[0];
      // mete las coordenadas en el arreglo
      this.polygonPoints = coordinates;
  
      var points = this.mapHelperService._map.getSource("pointsSource")._data;
      if(!environment.production) console.log("puntos", points);

      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, polygon);
      var features = turfFeaturesInsideArea.features;
      if(!environment.production) console.log("features", turfFeaturesInsideArea, features);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
      this.mapHelperService.featuresInsideArea.next(featuresResult);
  
      // this.panelAddGeofencesService.setIntersectedFeatures(features);
    } else {
      this.polygonPoints = [];
    }
  }

  polygonSelectionChange = (e) => {
    if (e.features.length > 0) {
      this.originalGeofencePolygonDrawData = this.drawGeofencePolygon.getAll();
    }
  }

  addGeofencePolygonDrawControl(){
    this.removeAllPolygonDrawControls();
    this.mapHelperService.addControl(this.drawGeofencePolygon);

    this.mapHelperService.onDrawSelectionChange(this.polygonSelectionChange);
    this.mapHelperService.onDrawCreate(this.updatePolygonArea);
    this.mapHelperService.onDrawDelete(this.updatePolygonArea);
    this.mapHelperService.onDrawUpdate(this.updatePolygonAreaWithConfirmation);
  }

  removeGeofencePolygonDrawControl(){
    try {
      this.drawGeofencePolygon.deleteAll();
      this.isPolygonUpdateConfirmed = false;
      
      this.mapHelperService.offDrawSelectionChange(this.polygonSelectionChange);
      this.mapHelperService.offDrawCreate(this.updatePolygonArea);
      this.mapHelperService.offDrawDelete(this.updatePolygonArea);
      this.mapHelperService.offDrawUpdate(this.updatePolygonAreaWithConfirmation);
      this.mapHelperService.removeControl(this.drawGeofencePolygon);
    } catch (error) {}
  }

  //#endregion

  //#region dibujador de buffer en geocerca
  drawGeofenceBuffer = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
      polygon: false,
      trash: false,
      combine_features: false,
      uncombine_features: false,
    },
    defaultMode: 'simple_select',
    touchEnabled: false,
    boxSelect: false,
    styles: customDrawStyles,
  });

  updateBufferAreaWithConfirmation = async (e) => {
    if (!this.isBufferUpdateConfirmed){
      const resp = await this.swalNotificationService.confirmMessage("¿Deseas modificar el área de la geocerca?", 'Se actualizarán los puntos que se encuentran dentro de la geocerca.');
      if (!resp.isConfirmed){
        this.drawGeofenceBuffer.set(this.originalGeofenceBufferDrawData);
        return;
      }
      this.isBufferUpdateConfirmed = true;
    }

    const data = this.drawGeofenceBuffer.getAll();
    if (data.features.length > 0) {
      var polygon = data.features[0] as any;
      const coordinates = polygon.geometry.coordinates[0];
      // mete las coordenadas en el arreglo
      this.polygonPoints = coordinates;
  
      var points = this.mapHelperService._map.getSource("pointsSource")._data;
      if(!environment.production) console.log("puntos", points);

      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, polygon);
      var features = turfFeaturesInsideArea.features;
      if(!environment.production) console.log("features", turfFeaturesInsideArea, features);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Geofences };
      this.mapHelperService.featuresInsideArea.next(featuresResult);

      const centroid = this.turfHelperService.getFeatureCentroidGeoJSON(polygon);

      const latLang = centroid?.geometry?.coordinates;
      console.log("polygon draw", latLang);
      
      this.setPolygonCentroid(latLang? latLang : [0,0]);
  
      // this.panelAddGeofencesService.setIntersectedFeatures(features);
    } else {
      this.polygonPoints = [];
      console.log("polygon draw empty");
      this.setPolygonCentroid([0,0]);
    }
  }

  bufferSelectionChange = (e) => {
    if (e.features.length > 0) {
      this.originalGeofenceBufferDrawData = this.drawGeofenceBuffer.getAll();
    }
  }
  
  addGeofenceBufferDrawControl(){
    this.removeAllPolygonDrawControls();
    this.mapHelperService.addControl(this.drawGeofenceBuffer);

    this.mapHelperService.onDrawSelectionChange(this.bufferSelectionChange);
    this.mapHelperService.onDrawUpdate(this.updateBufferAreaWithConfirmation);
  }

  hasBufferDrawControl(){
    try {
      return this.mapHelperService.hasControl(this.drawGeofenceBuffer);
    } catch (error) {
      return false;
    }
  }

  removeGeofenceBufferDrawControl(){
    try {
      this.drawGeofenceBuffer.deleteAll();
      this.isBufferUpdateConfirmed = false;
      
      this.mapHelperService.offDrawSelectionChange(this.bufferSelectionChange);
      this.mapHelperService.offDrawUpdate(this.updateBufferAreaWithConfirmation);
      this.mapHelperService.removeControl(this.drawGeofenceBuffer);
      this.setPolygonCentroid([]);
    } catch (error) {}
  }

//#endregion
  
//#region dibujador de intersección con capas principales
    drawIntersectToolPolygon = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: false,
        trash: false,
        combine_features: false,
        uncombine_features: false,
        point: false,
      },
      styles: customDrawStyles,
    });
  
    private intersectMainLayerPolygonAreaHandler = (e) => {
      const data = this.drawIntersectToolPolygon.getAll();
      var turfFeaturesInsideArea = { type: "FeatureCollection", features: [] } as FeatureCollection<Point>;
      if (data.features.length > 0) {
        var area = data.features[0] as any;
        if(!environment.production) console.log("layers ", this.mapHelperService.activeLayers);
          this.mapHelperService.activeLayers.forEach((layer) => {
            if (layer.checked){
              var points;
              if (layer.name == "layer-locationsGeneral") {
                 points = this.mapHelperService._map.getSource("pointsSource")._data;
              }else{
                if (layer.name == "filter-layer-locationsGeneral") {
                   points = this.mapHelperService._map.getSource("filterPointsSource")._data;
                }else{
                  points = this.mapHelperService._map.getSource(layer.name + "-source")._data;
                }
              }
                if(!environment.production) console.log("puntos "+layer.name, points, this.turfHelperService.getPointsWithinPolygon(points, area));
                turfFeaturesInsideArea.features.push(... this.turfHelperService.getPointsWithinPolygon(points, area).features);
            }
            
          });
  
          if(!environment.production) console.log("features inside area", turfFeaturesInsideArea);
          var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Tool };
          this.mapHelperService.featuresInsideArea.next(featuresResult);
          // this.toolCarsSelectorservice.setIntersectedFeatures(this.featuresInsideArea.features);
      } else {
        if(!environment.production) console.log("features", this.mapHelperService.featuresInsideArea);
        var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Tool };
        this.mapHelperService.featuresInsideArea.next(featuresResult);
        // this.toolCarsSelectorservice.setIntersectedFeatures(this.featuresInsideArea.features);
      }
    }
  
    toggleToolMainLayerIntersectDrawControl(activate: boolean) {
      if(!environment.production) console.log("toggleToolMainLayerIntersectDrawControl", activate);
      
      if (activate) {
        this.removeAllPolygonDrawControls();
        this.mapHelperService.addControl(this.drawIntersectToolPolygon);
  
        this.mapHelperService.onDrawCreate(this.intersectMainLayerPolygonAreaHandler);
        this.mapHelperService.onDrawDelete(this.intersectMainLayerPolygonAreaHandler);
        this.mapHelperService.onDrawUpdate(this.intersectMainLayerPolygonAreaHandler);
      } else {
        try {
          this.drawIntersectToolPolygon.deleteAll();
          this.mapHelperService.offDrawCreate(this.intersectMainLayerPolygonAreaHandler);
          this.mapHelperService.offDrawDelete(this.intersectMainLayerPolygonAreaHandler);
          this.mapHelperService.offDrawUpdate(this.intersectMainLayerPolygonAreaHandler);
          this.mapHelperService.removeControl(this.drawIntersectToolPolygon);
        } catch (error) {}
      }
    }
  
    private intersectFilterLayerPolygonAreaHandler = (e) => {
      const data = this.drawIntersectToolPolygon.getAll();
      var featuresResult = null;
      var turfFeaturesInsideArea = null;
      if (data.features.length > 0) {
        var area = data.features[0] as any;
        var points = this.mapHelperService._map.getSource("filterPointsSource")._data;
        if(!environment.production) console.log("puntos", points);
        turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon( points, area );
        var features = turfFeaturesInsideArea.features;
        if(!environment.production) console.log("features", features);
        featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Tool };
        this.mapHelperService.featuresInsideArea.next(featuresResult);
        // this.toolCarsSelectorservice.setIntersectedFeatures(features);
        // this.toolCarsSelectorservice.setAvailabilityButton(true);
      } else {
        turfFeaturesInsideArea = this.mapHelperService.Empty_GeoJson;
        if(!environment.production) console.log("features", turfFeaturesInsideArea);
        featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Tool };
        this.mapHelperService.featuresInsideArea.next(featuresResult);
        // this.toolCarsSelectorservice.setIntersectedFeatures(featuresInsideArea.features);
        // this.toolCarsSelectorservice.setAvailabilityButton(false);
      }
    }
  
    toggleToolFilterLayerIntersectDrawControl(activate: boolean) {
      if(!environment.production) console.log("toggleToolFilterLayerIntersectDrawControl", activate);
      if (activate) {
        this.removeAllPolygonDrawControls();
        this.mapHelperService.addControl(this.drawIntersectToolPolygon);

        this.mapHelperService.onDrawCreate(this.intersectFilterLayerPolygonAreaHandler);
        this.mapHelperService.onDrawDelete(this.intersectFilterLayerPolygonAreaHandler);
        this.mapHelperService.onDrawUpdate(this.intersectFilterLayerPolygonAreaHandler);
      } else {
        try {
          this.drawIntersectToolPolygon.deleteAll();
          this.mapHelperService.offDrawCreate(this.intersectFilterLayerPolygonAreaHandler);
          this.mapHelperService.offDrawDelete(this.intersectFilterLayerPolygonAreaHandler);
          this.mapHelperService.offDrawUpdate(this.intersectFilterLayerPolygonAreaHandler);
          this.mapHelperService.removeControl(this.drawIntersectToolPolygon);
        } catch (error) {}
      }
    }

//#endregion

//#region dibujador de geocercas
  // ------------- dibujador de poligono --------------
  drawTerritoryLocationPolygon = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
      polygon: false,
      trash: false,
      combine_features: false,
      uncombine_features: false,
    },
    styles: customDrawStyles,
  });

  updateTerritoryLocationPolygonArea = (e) => {
    const data = this.drawTerritoryLocationPolygon.getAll();
    if (data.features.length > 0) {
      var polygon = data.features[0] as any;
      const coordinates = polygon.geometry.coordinates[0];
      // mete las coordenadas en el arreglo
      this.polygonPoints = coordinates;
  
      const source = this.mapHelperService._map.getSource("territory-location-source-all");
      if (!source || !source._data) {
        var emptyFeaturesResult = { 
          featureCollection: this.mapHelperService.Empty_GeoJson, 
          destination: EnumFeaturesActionsDestinations.Territories 
        };
        this.mapHelperService.featuresInsideArea.next(emptyFeaturesResult);
        return;
      }

      var points = source._data;

      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, polygon);
      var features = turfFeaturesInsideArea.features;
      if(!environment.production) console.log("features dentro del polígono", features);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Territories };
      this.mapHelperService.featuresInsideArea.next(featuresResult);
  
      // this.panelAddGeofencesService.setIntersectedFeatures(features);
    } else {
      this.polygonPoints = [];
    }
  }

  updateTerritoryLocationPolygonAreaWithConfirmation = async (e) => {
   
    // if (!this.isPolygonUpdateConfirmed){
    //   const resp = await this.swalNotificationService.confirmMessage("¿Deseas modificar el área del territorio?", 'Se actualizarán los puntos que se encuentran dentro del territorio.');
    //   if (!resp.isConfirmed){
    //     this.drawTerritoryLocationPolygon.set(this.originalTerritoryLocationPolygonDrawData);
    //     return;
    //   }
    //   this.isPolygonUpdateConfirmed = true;
    // }

    const data = this.drawTerritoryLocationPolygon.getAll();
    if (data.features.length > 0) {
      var polygon = data.features[0] as any;
      const coordinates = polygon.geometry.coordinates[0];
      // mete las coordenadas en el arreglo
      this.polygonPoints = coordinates;
  
      const source = this.mapHelperService._map.getSource("territory-location-source-all");
      if (!source || !source._data) {
        return;
      }

      var points = source._data;
      if(!environment.production) console.log("puntos", points);

      var turfFeaturesInsideArea = this.turfHelperService.getPointsWithinPolygon(points, polygon);
      var features = turfFeaturesInsideArea.features;
      if(!environment.production) console.log("features", turfFeaturesInsideArea, features);
      var featuresResult = { featureCollection: turfFeaturesInsideArea, destination: EnumFeaturesActionsDestinations.Territories };
      this.mapHelperService.featuresInsideArea.next(featuresResult);
  
      // this.panelAddGeofencesService.setIntersectedFeatures(features);
    } else {
      this.polygonPoints = [];
    }
  }

  // territoryLocationPolygonSelectionChange = (e) => {
  //   if (e.features.length > 0) {
  //     this.originalTerritoryLocationPolygonDrawData = this.drawTerritoryLocationPolygon.getAll();
  //   }
  // }

  addTerritoryLocationPolygonDrawControl(){
    this.removeAllPolygonDrawControls();
    this.mapHelperService.addControl(this.drawTerritoryLocationPolygon);

    this.drawTerritoryLocationPolygon.changeMode('draw_polygon');

    // this.mapHelperService.onDrawSelectionChange(this.territoryLocationPolygonSelectionChange);
    this.mapHelperService.onDrawCreate(this.updateTerritoryLocationPolygonArea);
    this.mapHelperService.onDrawDelete(this.updateTerritoryLocationPolygonArea);
    this.mapHelperService.onDrawUpdate(this.updateTerritoryLocationPolygonAreaWithConfirmation);
  }

  removeTerritoryLocationPolygonDrawControl(){
    try {
      this.drawTerritoryLocationPolygon.deleteAll();
      this.isPolygonUpdateConfirmed = false;
      
      // this.mapHelperService.offDrawSelectionChange(this.territoryLocationPolygonSelectionChange);
      this.mapHelperService.offDrawCreate(this.updateTerritoryLocationPolygonArea);
      this.mapHelperService.offDrawDelete(this.updateTerritoryLocationPolygonArea);
      this.mapHelperService.offDrawUpdate(this.updateTerritoryLocationPolygonAreaWithConfirmation);
      this.mapHelperService.removeControl(this.drawTerritoryLocationPolygon);
    } catch (error) {}
  }

  //#endregion



  removeAllPolygonDrawControls() {
    this.removeGeofencePolygonDrawControl();
    this.removeGeofenceBufferDrawControl();
    this.toggleToolMainLayerIntersectDrawControl(false);
    this.toggleToolFilterLayerIntersectDrawControl(false);
    this.removeTerritoryLocationPolygonDrawControl();
  }
  
}
